import Button from "components/BaseWidgets/button";
import "./style.scss";
import Tag from "components/BaseWidgets/tag";
import { priceFormatPrice } from "utils/formatHelper";

function AddOnCard({
  data: { badge, title, validity, price, views },
  onClick,
  isLoading,
}) {
  return (
    <div className={`add-on-card `}>
      {badge && (
        <Tag readOnly className="popular-tag" variant="yellow">
          {badge}
        </Tag>
      )}
      <div className="flex flex-col gap-2 items-center">
        <span className="font-title-normal leading-1">{title}</span>
        <p className="font-body-normal fw-700 leading-1">
          {validity} days validity
        </p>
      </div>
      <div className="flex flex-col gap-0-5 items-center">
        <span className="font-title-xl leading-1">
          {priceFormatPrice(price)}
        </span>
        <p className="font-title-xs fw-500 leading-5">{views} contact view</p>
      </div>
      <Button
        isLoading={isLoading}
        onClick={onClick}
        wFull
        height={30}
        className="add-btn"
        variant="secondary"
      >
        Add
      </Button>
    </div>
  );
}

export default AddOnCard;
